import React from "react";
import {
  DeleteForever as DeleteForeverIcon,
  Edit as EditIcon,
} from '@mui/icons-material';
import { MenuItem } from '@mui/material';
import { DataGridActionMenu, DataGridListPage } from 'pages/Common';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { deleteDataGridRow } from 'store/actions';
import { pageKeys } from 'store/reducers/dataGrid.reducer';
import { getSportName } from 'utils';
import apiEndpoints from "constants/endpoints";


export const SponsorList = () => {
  const history = useHistory();
  const sportsById = useSelector(state=> state.sports.sportsById);
  const dispatch = useDispatch();

  const onDelete = useCallback((id) => {
    const confirmed = window.confirm("Are you sure you want to delete this sponsor permanently?");
    if (confirmed) {
      dispatch(deleteDataGridRow(apiEndpoints.sponsors, id, {}, {}, pageKeys.sponsorList));
    }
  }, [dispatch]);
  
  const columns = useMemo(() => {

    return [
      {
        field: 'id',
        headerName: 'Id',
        width: 80,
      },
      {
        field: 'sportId',
        headerName: 'Sport',
        width: 200,
        valueFormatter: ({ value }) => getSportName(sportsById, value),
      },
      {
        field: 'label',
        headerName: 'Label',
        width: 300,
      },
      {
        field: 'logo',
        headerName: 'Logo',
        width: 100,
        cellRenderer: ({value}) => <img src={`https://kozoom.b-cdn.net/uploads/sponsors/${value}`} width="100%" alt="Logo" />

      },
      {
        field: 'actions',
        headerName: 'Actions',
        flex: 1,
        cellStyle: {textAlign: 'center'},
        headerClass: 'text-center',
        cellRenderer: ({ data }) => (
          <>
            <DataGridActionMenu>
              <MenuItem onClick={() => history.push(`/${apiEndpoints.sponsors}/${data.id}`)}><EditIcon />Edit</MenuItem>
              <MenuItem onClick={() => onDelete(data.id)}><DeleteForeverIcon/>Remove</MenuItem>
            </DataGridActionMenu>
          </>
        ),
      },
    ]
  }, [history, sportsById, onDelete]);

  return <DataGridListPage
    columns={columns}
    filters={[]}
    apiEndpoint={apiEndpoints.sponsors}
    heading="Sponsors"
    hasPagination={false}
    onAdd={() => history.push(`/${apiEndpoints.sponsors}/new`)}
    pageKey={pageKeys.sponsorList}
  />
}

